import { createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b3cd5292")

_pushScopeId("data-v-b3cd5292")
const _hoisted_1 = { class: "checkbox-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_3 = { class: "checkboxtext" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("span", _hoisted_1, [
    _createVNode("input", {
      class: "inp-cbx",
      checked: _ctx.checked,
      value: _ctx.value,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateInput($event.target.checked))),
      name: _ctx.name || _ctx.guid,
      id: _ctx.guid,
      type: "checkbox",
      style: {"display":"none"}
    }, null, 40, ["checked", "value", "name", "id"]),
    _createVNode("label", {
      class: ["cbx same-size w-100", { 'single-line': _ctx.singleLine }],
      for: _ctx.guid,
      tabindex: _ctx.tabIndex
    }, [
      _hoisted_2,
      _createVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], {}, true)
      ])
    ], 10, ["for", "tabindex"])
  ]))
})